import ListProcesses from "@/views/agro_exporter/finances/query_container_outcomes/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/finances/query_container_outcomes/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/agro_exporter/finances/query_container_outcomes/show_process/Containers.vue";
import ShowProcessExportInvoices from "@/components/views/agro_exporter/finances/query_container_outcomes/show_process/OrgInvoices.vue";
import ShowContainer from "@/views/agro_exporter/finances/query_container_outcomes/ShowContainer.vue";
import ShowOrgInvoice from "@/views/agro_exporter/finances/query_container_outcomes/ShowOrgInvoice.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "finances",
  permission: "query_container_outcomes"
});

export default [
  {
    path: "/ae/:agro_exporter_id/finances/query_container_outcomes/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_outcomes/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
   {
    path: "/ae/:agro_exporter_id/finances/query_container_outcomes/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        alias: "",
        component: ShowProcessContainers,
        props: true
      },
      {
        path: "org_invoices",
        name: routeName("show_process_org_invoices"),
        alias: "",
        component: ShowProcessExportInvoices,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_outcomes/:agro_exporter_process_id/show_container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_outcomes/:agro_exporter_process_id/show_org_invoice/:org_invoice_id/:container_id",
    name: routeName("show_org_invoice"),
    component: ShowOrgInvoice,
    props: true,
    meta: META
  }
]
